import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Avatar from '../Avatar';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Tooltip } from '@material-ui/core';
import DropdownMenu from '../DropdownMenu';

const INVITE_OPTIONS = ['Invite as Member', 'Invite as Admin'];

class InviteUser extends React.PureComponent {
    onClick = action => {
        const {
            inviteUser,
            resendInvite,
            email,
            existingInvitation,
        } = this.props;

        if (existingInvitation) {
            resendInvite(existingInvitation);
        } else {
            inviteUser({
                email,
                isAdmin: INVITE_OPTIONS.indexOf(action) === 1,
            });
        }
    };

    render() {
        const {
            email,
            classes,
            existingInvitation,
            alreadyMember,
        } = this.props;

        let inviteOptions;
        let resendInvitation;

        if (existingInvitation) {
            resendInvitation = (
                <Tooltip title="Resend Invitation" placement="right">
                    <Button color="primary" onClick={this.onClick}>
                        RESEND INVITATION
                    </Button>
                </Tooltip>
            );
        } else {
            inviteOptions = (
                <DropdownMenu actions={INVITE_OPTIONS} onClick={this.onClick} />
            );
        }

        const alreadyInvitedMessage =
            existingInvitation || alreadyMember ? (
                <i className={classes.alreadyInvited}>
                    {existingInvitation
                        ? '(Already Invited)'
                        : '(Already Member)'}
                </i>
            ) : null;

        return (
            <Paper square elevation={1} className={classes.wrapper}>
                <Avatar>
                    <i className="material-icons">person</i>
                </Avatar>
                <div className={classes.email}>
                    {alreadyInvitedMessage}
                    {email}
                </div>
                {resendInvitation}
                <div className={classes.inviteDropdown}>{inviteOptions}</div>
            </Paper>
        );
    }
}

InviteUser.propTypes = {
    email: PropTypes.string.isRequired,
    inviteUser: PropTypes.func.isRequired,
    resendInvite: PropTypes.func.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: spacing.unit * 6,
        paddingLeft: spacing.unit * 3,
    },
    email: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        paddingLeft: spacing.unit * 2,
    },
    alreadyInvited: {
        paddingRight: spacing.unit,
    },
    inviteDropdown: {
        marginRight: spacing.unit * 2,
    },
});

export default injectSheet(style)(InviteUser);



// WEBPACK FOOTER //
// ./src/components/invitations/InviteUser.js